import ACTIONS from "./action";
import commonReducers from "@tailormed/common-client/store/reducer";
import { defaultFilters, defaultMultiples } from "../constant/filters";
import { ReportColumns } from "../component/Reports/ReportColumns";

const defaultState = {
  auth: undefined,
  environment: undefined,
  user: undefined,
  idpConfig: undefined,
  oktaClientId: undefined,
  networkActions: {},
  isPhiAllowed: undefined,
  tier: undefined,
  settings: {},
  showContactSupportModal: false,
  filters: defaultFilters,
  multiples: defaultMultiples,
  reportData: undefined,
  reportColumns: ReportColumns,
  enrollmentsReportData: undefined,
  enrollmentClaimsReportData: undefined,
  claimsReportData: undefined,
  userGroups: [],
  ordersReportData: undefined,
  completedOrdersReportData: undefined,
  ...commonReducers.defaultState
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACTIONS.Types.SET_AUTH: {
      const { auth } = action;
      return { ...state, auth: { ...state.auth, ...auth } };
    }

    case ACTIONS.Types.SET_ENVIRONMENT: {
      const { environment } = action;
      return { ...state, environment };
    }

    case ACTIONS.Types.SET_IDP_CONFIG: {
      const { idpConfig } = action;
      return { ...state, idpConfig };
    }

    case ACTIONS.Types.SET_USER: {
      const { user } = action;
      return { ...state, user };
    }

    case ACTIONS.Types.SET_OKTA_CONFIG: {
      const { oktaClientId } = action;
      return { ...state, oktaClientId };
    }

    case ACTIONS.Types.SET_IS_PHI_ALLOWED: {
      const { isPhiAllowed } = action;
      return { ...state, isPhiAllowed };
    }

    case ACTIONS.Types.SET_TIER: {
      const { tier } = action;
      return { ...state, tier };
    }

    case ACTIONS.Types.SET_NETWORK_ACTION: {
      const { actionType, isFetching, msg, code } = action;
      return { ...state, networkActions: { ...state.networkActions, [actionType]: { isFetching, msg, code } } };
    }

    case ACTIONS.Types.SET_SETTINGS: {
      const { settings } = action;
      const settingsObject = {};
      settings.map((setting) => (settingsObject[setting.key] = setting));
      return { ...state, settings: settingsObject };
    }

    case ACTIONS.Types.SET_SHOW_CONTACT_SUPPORT_MODAL: {
      const { showContactSupportModal } = action;
      return { ...state, showContactSupportModal };
    }

    case ACTIONS.Types.SET_TABLEAU_TOKEN: {
      const { tableauToken } = action;
      return { ...state, tableauToken };
    }

    case ACTIONS.Types.SET_FILTERS: {
      const { filters } = action;
      return { ...state, filters };
    }

    case ACTIONS.Types.PROVIDERS_ACTION: {
      const { providers } = action;
      return { ...state, providers };
    }

    case ACTIONS.Types.SET_ASSIGNEES: {
      const { assignees } = action;
      return { ...state, assignees };
    }

    case ACTIONS.Types.SET_MULTIPLES: {
      const { multiples } = action;
      return { ...state, multiples };
    }

    case ACTIONS.Types.SET_ENROLLMENTS_REPORT_DATA: {
      const { enrollmentsReportData } = action;
      return { ...state, enrollmentsReportData };
    }

    case ACTIONS.Types.SET_ENROLLMENT_CLAIMS_REPORT_DATA: {
      const { enrollmentClaimsReportData } = action;
      return { ...state, enrollmentClaimsReportData };
    }

    case ACTIONS.Types.SET_CLAIMS_REPORT_DATA: {
      const { claimsReportData } = action;
      return { ...state, claimsReportData };
    }

    case ACTIONS.Types.SET_USER_GROUPS: {
      const { userGroups } = action;
      return { ...state, userGroups };
    }

    case ACTIONS.Types.SET_ORDERS_REPORT_DATA: {
      const { ordersReportData } = action;
      return { ...state, ordersReportData };
    }

    case ACTIONS.Types.SET_COMPLETED_ORDERS_REPORT_DATA: {
      const { completedOrdersReportData } = action;
      return { ...state, completedOrdersReportData };
    }

    case ACTIONS.Types.SET_REPORT_COLUMNS: {
      const { reportColumns } = action;
      return { ...state, reportColumns };
    }

    default: {
      return commonReducers.reducer(state, action);
    }
  }
};

export default reducer;
